export default __webpack_public_path__ + "static/media/p3-13.9b2eb7d2.png";